module.exports = "/images/play-no-transition.svg?f0595ca8b816c5a64e9bda7fe5fc62c9";